import { cn } from '~/shadcn/lib/utils'
import { AmbassadorInviteBanner } from '~/@biz_ambassador/claim/AmbassadorInviteBanner'
import type { IPublicAmbassadorInfoData } from '~/@api/generated-api-types-ambassador/Api'

type Props = {
  isOpen: boolean
  info: IPublicAmbassadorInfoData | undefined
}

export function MyAmbassadorInviteBannerCollapse({ isOpen, info }: Props) {
  return (
    <div
      className={cn(
        'grid transition-[grid-template-rows] duration-300 ease-out',
        isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
      )}>
      <div className="overflow-hidden">
        {info && (
          <div
            className={cn(
              'pb-5 transition-opacity duration-300 ease-out',
              isOpen ? 'opacity-100' : 'opacity-0'
            )}>
            <AmbassadorInviteBanner
              reference={info.reference}
              description="Stlačte tlačidlo aktivovať a ambasádor vám pomôže zorientovať sa vo svete investícií."
            />
          </div>
        )}
      </div>
    </div>
  )
}
